export const REFPROV = {
  navReferringProviders: "nav-referring-providers",
  page: "referring-providers-page",
  title: "referring-providers-title",
  banner: "referring-providers-reference-banner",
  table: "referring-providers-table",
  loading: "referring-providers-loading",
  emptyState: "referring-providers-empty",
  errorState: "referring-providers-error",
  row: "referring-providers-row",
};
